import { yupResolver } from '@hookform/resolvers/yup';
import type { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { theme, ButtonVariant, FormInput } from '@catalyze/ui';
import { emailValidationRule } from 'schemas/validationRules';

import { StyledForm, StyledButton } from './styled';

interface IFormData {
    email: string;
}

interface IResetFormProps {
    onSubmit: (data: IFormData) => void;
}

export const ResetForm: FC<IResetFormProps> = ({ onSubmit }) => {
    const formMethods = useForm<IFormData>({
        resolver: yupResolver(
            yup.object({
                email: emailValidationRule,
            })
        ),
    });

    const { handleSubmit } = formMethods;

    return (
        <FormProvider {...formMethods}>
            <StyledForm onSubmit={handleSubmit(onSubmit)}>
                <FormInput label="Email" id="email" />
                <StyledButton
                    type="submit"
                    variant={ButtonVariant.TERTIARY}
                    color={theme.colors.bgPrimary}
                    bgColor={theme.colors.closed}
                >
                    Send email
                </StyledButton>
            </StyledForm>
        </FormProvider>
    );
};
